import * as api from '../api';
import { RESTAURANT_VENDOR_STATS_FAIL, RESTAURANT_VENDOR_STATS_REQUEST, RESTAURANT_VENDOR_STATS_SUCCESS } from "../constants/webOrderConstants";

// `opts.outletId`: the branch the navbar shows (undefined = every location this login may see).
export const fetchRestaurantVendorOrderStats = (vendorId, opts = {}) => async (dispatch) => {
    try {
        dispatch({ type: RESTAURANT_VENDOR_STATS_REQUEST });

        const { data } = await api.apiFetchRestaurantVendorStat(vendorId, opts);
        // console.log("Fetched stats from API:", data);
        dispatch({
            type: RESTAURANT_VENDOR_STATS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        console.error("Failed to fetch stats:", error);
        dispatch({
            type: RESTAURANT_VENDOR_STATS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
